import * as actionTypes from 'constants/ActionTypes';

export function getRealCompanies() {
    return {
        type: actionTypes.GET_REAL_COMPANIES.REQUEST,
    };
}


// WEBPACK FOOTER //
// ./app/actions/realCompanies.js